<div class="stripe-lookup-container">
  <h1>Stripe Lookup</h1>
  
  <p>Look up Stripe information by Event, Payment Intent, or Customer ID</p>
  
  <div class="forms-container">
    <!-- Event Lookup Form -->
    <div class="lookup-form">
      <h2>Event Lookup</h2>
      <p class="form-description">e.g., evt_3SFIzTDxA9qd6lS00uTVwzMg</p>
      <form [formGroup]="eventForm" (ngSubmit)="lookupEvent($event)">
        <div class="form-group">
          <label for="eventId">Event ID:</label>
          <input 
            type="text" 
            id="eventId"
            formControlName="eventId" 
            placeholder="evt_..." 
            size="50" 
          />
        </div>

        <button type="submit" [disabled]="loading" class="btn-lookup">
          {{ loading ? 'Looking up...' : 'Lookup Event' }}
        </button>
      </form>
    </div>

    <!-- Payment Intent Lookup Form -->
    <div class="lookup-form">
      <h2>Payment Intent Lookup</h2>
      <p class="form-description">e.g., pi_3SFIzTDxA9qd6lS003LLhIc5</p>
      <form [formGroup]="paymentIntentForm" (ngSubmit)="lookupPaymentIntent($event)">
        <div class="form-group">
          <label for="paymentIntentId">Payment Intent ID:</label>
          <input 
            type="text" 
            id="paymentIntentId"
            formControlName="paymentIntentId" 
            placeholder="pi_..." 
            size="50" 
          />
        </div>

        <button type="submit" [disabled]="loading" class="btn-lookup">
          {{ loading ? 'Looking up...' : 'Lookup Payment Intent' }}
        </button>
      </form>
    </div>

    <!-- Customer Lookup Form -->
    <div class="lookup-form">
      <h2>Customer Lookup</h2>
      <p class="form-description">e.g., cus_1SFJ0UDxA9qd6lS06vZAXEHg</p>
      <form [formGroup]="customerForm" (ngSubmit)="lookupCustomer($event)">
        <div class="form-group">
          <label for="customerId">Customer ID:</label>
          <input 
            type="text" 
            id="customerId"
            formControlName="customerId" 
            placeholder="cus_..." 
            size="50" 
          />
        </div>

        <button type="submit" [disabled]="loading" class="btn-lookup">
          {{ loading ? 'Looking up...' : 'Lookup Customer' }}
        </button>
      </form>
    </div>

    <!-- Payment Method Lookup Form -->
    <div class="lookup-form">
      <h2>Payment Method Lookup</h2>
      <p class="form-description">e.g., pm_1SBJ7LDxA9qd6lS0hZmhzTAy</p>
      <form [formGroup]="paymentMethodForm" (ngSubmit)="lookupPaymentMethod($event)">
        <div class="form-group">
          <label for="paymentMethodId">Payment Method ID:</label>
          <input 
            type="text" 
            id="paymentMethodId"
            formControlName="paymentMethodId" 
            placeholder="pm_..." 
            size="50" 
          />
        </div>

        <button type="submit" [disabled]="loading" class="btn-lookup">
          {{ loading ? 'Looking up...' : 'Lookup Payment Method' }}
        </button>
      </form>
    </div>
  </div>

  <div *ngIf="error" class="error-message">
    <h3>Error:</h3>
    <pre>{{ error }}</pre>
  </div>

  <div *ngIf="result" class="results-wrapper">
    <div class="result-container">
      <h3>Structured Data:</h3>
      <pre class="json-result">{{ formatJson(result) }}</pre>
    </div>

    <div *ngIf="rawJson" class="raw-json-container">
      <h3>Raw Stripe Response:</h3>
      <pre class="json-result">{{ formatRawJson(rawJson) }}</pre>
    </div>
  </div>
</div>
